import React from 'react';
//import HubspotContactForm from './hubspotform';
import HubspotForm from "react-hubspot-form";
import './style.css';
import Constants from '../../../services/constants';

export default function ContactUs() {

  // Hubspot form, changed to Zoho form
  // return (
  //   <div className='flex text-center flex-wrap'>
  //     <div className='self-center text-center w-full'>
  //       <h1 className='w-full text-2xl pt-20'>Contact Us</h1>
  //       <div className='hform'>
  //       <HubspotForm
  //     portalId="23971077"
  //     formId="0f43af02-32a2-4477-b9f9-8cb2ab118fc4"
  //     onSubmit={() => console.log("Submit!")}
  //     onReady={(form) => console.log("Form ready!")}
  //     loading={<div></div>}
  //      />
  //     </div>
  //     </div>
  //   </div>
  // )

  return (
    <div style={{ width: '100%', height: '80vh', overflow: 'scroll', marginTop: '56px' }}>
      <iframe
        src={Constants.ZOHO_FORM_URL}
        width="100%"
        height="100%"
        style={{ border: 'none' }}
        title="Zoho Form"
      />
    </div>
  );
}